<template>
  <div>
    <Form ref="dataFormRef" :model="dataForm" :rules="dataFormValid" v-bind:label-width="90" label-position="left">
      <FormItem label="所在部门：" prop="applyDepartmentId">
        <Select v-model="dataForm.applyDepartmentId" placeholder="请选择" @on-change="applyDepartmentChange" disabled>
          <Option v-for="item in applyDepartmentList" :value="item.departmentRelId" :key="item.departmentRelId">{{ item.departmentName }}</Option>
        </Select>
      </FormItem>
      <FormItem label="修改原因：" prop="auditNote" v-if="isShowEditReason">
        <Input type="textarea" rowspan="2" v-model.trim="dataForm.auditNote" :disabled='isDisabledEditReason' placeholder="请输入修改原因"></Input>
      </FormItem>
    </Form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dataFormValid: {
        auditNote: { required: true, message: '请输入修改原因', trigger: 'blur' }
      }
    };
  },
  props: {
    dataForm: {
      type: Object,
      derault: function() {
        return {
          applyDepartmentId: '',
          auditNote: ''
        };
      }
    },
    applyDepartmentList: { // 部门列表
      type: Array,
      default: []
    },
    instStatus: Number, // 总的状态值
    isShowEditReason: { // 是否显示修改原因
      type: Boolean,
      default: false
    },
    isDisabledEditReason: { // 是否禁用修改原因
      type: Boolean,
      default: true
    }
  },
  methods: {
    applyDepartmentChange(e) {
      const applyDepartmentName = this.applyDepartmentList.find(item => item.departmentRelId == e).departmentName;
      this.$emit('applyDepartmentChange', applyDepartmentName);
    },
    submitValid(callback) {
      this.$refs['dataFormRef'].validate(valid => {
        callback(valid);
      });
    }
  }
};
</script>

<style>

</style>
